import "./Footer.css";
import { FaInstagram, FaGithub, FaSpotify, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="social-media-icons-box">
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.instagram.com/nichtowen/"
        >
          <FaInstagram className="social-media-icons" />
        </a>
        <a target="_blank" rel="noreferrer" href="https://github.com/du-owen">
          <FaGithub className="social-media-icons" />
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://open.spotify.com/artist/2CHk4Jc3gmwFn2w8t6SXoX?si=fsVS2WscRMqunm6GI5hwKw"
        >
          <FaSpotify className="social-media-icons" />
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/in/owen-du"
        >
          <FaLinkedinIn className="social-media-icons" />
        </a>
      </div>
    </div>
  );
};

export default Footer;
